<h1 mat-dialog-title>Your Choice for Privacy Policy</h1>
<div mat-dialog-content>
    <p>{{ message }}</p>
</div>
<div class="CookieButtons" mat-dialog-actions [align]="'end'">
  <button class="ButtonAccept mr-3" [mat-dialog-close]="true" cdkFocusInitial>Accept</button>
  <button class="ButtonReject" [mat-dialog-close]="false">Reject</button>
</div>
